// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.user.UserInfo
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { UserRole } from "abweb/dto/generated/user/UserRole";
import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class UserInfoBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createUserInfoBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadu.UserInfo";
  }
  initFromJson(json, deserializeContext) {
    this.initUserInfo(json.authenticated, json.displayName != null ? json.displayName : null, json.passwordExternallyManaged != null ? json.passwordExternallyManaged : null, json.roles != null ? TSOGUtils.decodeObjectArray(json.roles, UserRole, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "roles")) : null, json.username != null ? json.username : null, json.usesSSO != null ? json.usesSSO : null);
  }
  initUserInfo(authenticated, displayName, passwordExternallyManaged, roles, username, usesSSO) {
    this.initKendoObservableObjectProxy();
    this._authenticated = authenticated;
    this._displayName = displayName;
    this._passwordExternallyManaged = passwordExternallyManaged;
    this._roles = roles;
    this._username = username;
    this._usesSSO = usesSSO;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["authenticated"] = this._authenticated;
    retVal["displayName"] = this._displayName;
    retVal["passwordExternallyManaged"] = this._passwordExternallyManaged;
    retVal["roles"] = TSOGUtils.toTSOGArray(this._roles, serializeContext);
    retVal["username"] = this._username;
    retVal["usesSSO"] = this._usesSSO;
    return retVal;
  }
  get authenticated() {
    return this._authenticated;
  }
  set authenticated(value) {
    this._authenticated = value;
  }
  get displayName() {
    return this._displayName;
  }
  set displayName(value) {
    this._displayName = value;
  }
  get passwordExternallyManaged() {
    return this._passwordExternallyManaged;
  }
  set passwordExternallyManaged(value) {
    this._passwordExternallyManaged = value;
  }
  get roles() {
    return this._roles;
  }
  set roles(value) {
    this._roles = value;
  }
  get username() {
    return this._username;
  }
  set username(value) {
    this._username = value;
  }
  get usesSSO() {
    return this._usesSSO;
  }
  set usesSSO(value) {
    this._usesSSO = value;
  }
}
//# sourceMappingURL=UserInfoBase.js.map
